import { useQuery } from '@tanstack/react-query'
import AnalyticsApi from '@/infrastructure/api/analytics'
import { useAnalyticsScope } from '@/hooks'

export function useProductCountryReturnRate(
  isReturnRateAnalyticsAllowed: boolean,
  productId?: string,
  startDate?: string,
  endDate?: string,
  countries?: string[]
) {
  const { ecommerceIds } = useAnalyticsScope()

  async function callProductCountryReturnRate() {
    if (!ecommerceIds.length || !productId) return
    return AnalyticsApi.getProductCountryReturnRate({
      productId,
      ecommerceId: ecommerceIds[0],
      ecommerceIds,
      startDate,
      endDate,
      countries
    })
  }

  const countryReturnRateQuery = useQuery({
    queryKey: [
      'productCountryReturnRate',
      productId,
      ecommerceIds,
      startDate,
      endDate,
      countries
    ],
    queryFn: callProductCountryReturnRate,
    staleTime: 1000 * 60 * 15,
    enabled:
      ecommerceIds.length > 0 &&
      !!productId &&
      !!startDate &&
      !!endDate &&
      isReturnRateAnalyticsAllowed &&
      countries !== undefined
  })

  return {
    productCountryReturnRate: countryReturnRateQuery.data,
    loadingProductCountryReturnRate: countryReturnRateQuery.isLoading
  }
}
